import { FormConfig } from 'src/app/shared/models/dynamic.model';

export interface RoutingModal {
  routingFacilityId: number | null;
  inDateFrom: Date | string | null;
  inDateTo: Date | string | null;
  outDateFrom: Date | string | null;
  outDateTo: Date | string | null;
}

export const defaultRoutingModal: RoutingModal = {
  routingFacilityId: null,
  inDateFrom: null,
  inDateTo: null,
  outDateFrom: null,
  outDateTo: null,
};

export interface RoutingModalStateModel {
  routingModal: RoutingModal;
}

export const defaultRoutingState: RoutingModalStateModel = {
  routingModal: defaultRoutingModal,
};

export const routingAdvancedSearchFormFieldsConfig: FormConfig = {
  fields: [
    {
      id: 'routingFacilityId',
      type: 'select',
      label: 'Routing facility',
    },
    {
      id: 'inDateFrom',
      type: 'datepicker',
      isDateRangeField: true,
      label: 'IN Date From',
    },
    {
      id: 'inDateTo',
      type: 'datepicker',
      isDateRangeField: true,
      label: 'IN Date To',
    },
    {
      id: 'outDateFrom',
      type: 'datepicker',
      isDateRangeField: true,
      label: 'Out Date From',
    },
    {
      id: 'outDateTo',
      type: 'datepicker',
      isDateRangeField: true,
      label: 'Out Date To',
    },
  ],
};
